window.priceUpdate = function () {
    var price = $("#hour_selector").find('option:selected').attr('price')
    $('#extra_hours').prop("disabled", $("#hour_selector").val() == 12)
    $("#base-price").html(price + ' UF')
}

var contributions = {}

const sumValues = obj => Object.values(obj).reduce((a, b) => a + b);

function updatePrice() {
    var value = sumValues(contributions)
    $("#extra-price").html(value.toFixed(2) + " UF");
}

window.updateContribution = function (price, text_id) {
    if ($('#' + text_id).is(':checked')) {
        $("#amount" + text_id).prop('disabled', false);
        var multiplier = $("#amount" + text_id).val();
        if (text_id == "accreditationTable") {
            if (multiplier < 2) {
                multiplier = 0
            } else {
                multiplier = multiplier - 2
            }
        }

        contributions[text_id] = price * ((multiplier != null) ? multiplier : 1);
        updatePrice()
    } else {
        $("#amount" + text_id).prop('disabled', true);
        $("#amount" + text_id).val(0);
        var multiplier = $("#amount" + text_id).val();
        contributions[text_id] = price * ((multiplier != null) ? multiplier : 0);
        $("#amount" + text_id).val(1);
        updatePrice()
    }
}


window.hour_extra_option = function (extra_hours_price) {
    var checked = $('#extra_hours').is(':checked')
    $("#hour_selector").prop("disabled", checked)
    $("#hour_backup").prop("disabled", !checked)
    if ($("#hour_selector").val() < 9 && checked) {
        $("#hour_selector").val(8)
        window.priceUpdate()
    }
    if ($("#hour_selector").val() == 9 && checked) {
        $("#hour_selector").val(11)
        window.priceUpdate()
    }
    $("#hour_backup").val($("#hour_selector").val())
    var price = parseFloat($("#base-price").html().replace(' UF'))
    var new_value = $('#extra_hours').is(':checked') ? price + extra_hours_price : price - extra_hours_price
    rounded = new_value.toFixed(2)
    $("#base-price").html(rounded + ' UF')
}

window.get_coffe_info = function (selector) {
    if (selector.value==-1) {
       $("#coffe-description-show").text('');
       $("#coffe-provider-show").text('');
       $("#coffe-price" ).text('');
    }
    $.post("/coffe/get_data", { coffe_id: selector.value }, function (data) {
        var description = data.description.replaceAll(".", ".<br/>")
       $("#coffe-description-show").html(description);
       $("#coffe-provider-show").text(data.provider);
       $("#coffe-price" ).text("$"+data.price.replace(".0", ''));
});
}

window.update_price_coffe = function(){
    var price = parseInt($("#final-price-coffe").text().replace("$", ""))
    var value = price + $("#amount-coffe").val() * parseInt($("#coffe-price").text().replace("$", ''))
    $("#final-price-coffe").text("$"+ value) 
}
